import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { App } from '@meronex/app';
import { SaveBtn } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ItemTypeForm from './ItemTypeForm';
import TopHeader from '../../../views/components/TopHeader';

import IBox from '@meronex/icons/fi/FiBox';

const { server } = App;

export default function AddItemTypeDialog(props) {
  const { open, onClose, onAdd, store } = props;
  const itemForm = React.useRef();

  const [formData, setFormData] = React.useState({});
  const [uploading, setUploading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const onSave = async () => {
    setLoading(true);
    if (formData && formData.values) {
      const item = formData.values;
      if (formData.values.image) {
        item.image = {
          imgUrl: formData.values.image.imgUrl,
          thumbUrl: formData.values.image.thumbUrl,
        };
      } else {
        item.image = undefined;
      }

      try {
        await server.call('addStoreItemType', item);
        toast.success('Store type was successfully added!', {
          autoClose: 1200,
        });
        if (typeof onAdd === 'function') {
          onAdd();
        }
        setLoading(false);
        onClose();
        reset();
      } catch (e) {
        setLoading(false);
        toast.error(e.reason || e.message || 'Could not add item type', {
          autoClose: 4000,
        });
      }
    }
  };

  function reset() {
    if (itemForm.current) {
      itemForm.current.reset();
    }
  }

  const _onClose = () => {
    reset();
    onClose();
  };

  return (
    <Dialog
      className={'fullScreenMobile'}
      maxWidth={'md'}
      open={open}
      onClose={_onClose}>
      <DialogTitle>
        <TopHeader
          title={'Add New Item Type'}
          onClose={_onClose}
          icon={<IBox size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        <ItemTypeForm
          ref={itemForm}
          store={store}
          validateOnInit={false}
          onUpdate={(d) => {
            setUploading(d.uploading);
            setFormData(d);
          }}
        />
        <SaveBtn
          loading={loading || uploading}
          disabled={loading || uploading || !formData.isValid}
          onClick={onSave}
          label={'Add'}
        />
      </DialogContent>
    </Dialog>
  );
}

AddItemTypeDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
  store: PropTypes.object,
};
